<div id="sellos-op-factoring" [ngClass]="{'d-flex align-items-center': isPanelInversor}">
  @if (tipoOperacionCodigo == 'con-seguro') {
  <img class="{{isPanelInversor ? 'mat-icon-size-40' : 'mat-icon-size-' + size}}" alt="sello operacion con seguro"
    src="assets/images/factoring/con-seguro.svg">
  }
  @if (tipoOperacionCodigo == 'sin-seguro') {
  <img class="{{isPanelInversor ? 'mat-icon-size-40': 'mat-icon-size-' + size}}" alt="sello operacion sin seguro"
    src="assets/images/factoring/sin-seguro.svg">
  }
  @if (tipoOperacionCodigo == 'admin-publica') {
  <img class="{{isPanelInversor ? 'mat-icon-size-40': 'mat-icon-size-' + size}}" alt="sello operacion admin-publica"
    src="assets/images/factoring/admin-publica.svg">
  }

  @if (isPanelInversor) {
  <div class="operacion-multiple text-start ps-3">
    @if (tipoOperacionCodigo == 'con-seguro') {
    <p class="p2-medium mt-2 ">Op. Con Seguro</p>
    }
    @if (tipoOperacionCodigo == 'admin-publica') {
    <p class="p2-medium mt-2">Op. Admón. Pública</p>
    }
    @if (tipoOperacionCodigo == 'sin-seguro') {
    <p class="p2-medium mt-2">Op. Sin Seguro</p>
    }
  </div>
  }
</div>